/*
 * @Author: QIYE
 * @Date: 2019-11-01 17:17:16
 * @LastEditors: qiye
 * @LastEditTime: 2020-07-01 18:08:37
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/assets/style/reset.css'
import 'swiper/dist/css/swiper.css'
import 'lib-flexible/flexible'
import Axios from 'axios'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import VueAnimateNumber from "vue-animate-number"
// import MetaInfo from 'vue-meta-info'


// Vue.use(MetaInfo)

Vue.use(VueAnimateNumber)
Vue.use(ElementUI)
Vue.prototype.$axios = Axios
/*使用VueResource插件*/
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.$video = Video

Vue.filter('parseInt', function (value) {
  console.log(value)
  return parseInt(value)
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  console.log(to.meta.content)
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    if (to.meta.content.keywords) {
      document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    }
    if (to.meta.content.description) {
      document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    }
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = process.env.VUE_APP_NAME + ' | ' + to.meta.title
  }
  // /*当进行页面跳转时定位在页面顶部*/
  // // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted() {
    document.dispatchEvent(new Event("custom-render-trigger"));
  }
})



// WEBPACK FOOTER //
// ./src/main.js